var _rect, _rect2, _rect3, _rect4, _polygon, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStrength(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "strength",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 51 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.83,
    y: 7,
    width: 5.36,
    height: 9.55
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 33.81,
    y: 7,
    width: 5.36,
    height: 9.55
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26.33,
    y: 7,
    width: 5.36,
    height: 9.55
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18.85,
    y: 7,
    width: 5.36,
    height: 9.55
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "33.81,28.4 18.85,28.4 18.85,25.51 31.69,25.51 31.69,19.44 18.85,19.44 11.83,19.44 11.83,25.51  11.83,34.28 17.99,34.28 18.85,34.28 33.81,34.28 39.17,34.28 39.17,28.4 39.17,19.44 33.81,19.44 "
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12.2,
    y: 37.18,
    className: "st0",
    width: 26.98,
    height: 6.82
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrength);
export default __webpack_public_path__ + "static/media/strength.b9763f1fefd21255e27acb4cd8b90255.svg";
export { ForwardRef as ReactComponent };